import { render, staticRenderFns } from "./WorkflowTriggersPlaceholder.vue?vue&type=template&id=624ab943&"
import script from "./WorkflowTriggersPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./WorkflowTriggersPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports